export const cropNutritionPrograms = [
    {
        label: 'BY CROPS',
        options: [
            { name: 'Cereals' },
            { name: 'Corn' },
            { name: 'Sunflower' },
            { name: 'Pulses' },
            { name: 'Winter rape' },
        ],
    },
    {
        label: 'BY GROUP OF PRODUCT',
        options: [
            { name: 'Cereals' },
            { name: 'Corn' },
            { name: 'Sunflower' },
            { name: 'Pulses' },
            { name: 'Winter rape' },
        ],
    },
];

export const trialResults = [
    {
        label: 'BY PRODUCTS',
        options: [{ name: 'Organic line' }, { name: 'Wuxal' }, { name: 'Fertiplant' }, { name: 'UniferX' }],
    },
    {
        label: 'BY CROPS',
        options: [
            { name: 'Cereals' },
            { name: 'Corn' },
            { name: 'Sunflower' },
            { name: 'Pulses' },
            { name: 'Winter rape' },
        ],
    },
    {
        label: 'BY COUNTRIES',
        options: [{ name: 'Ukraine' }, { name: 'Germany' }, { name: 'Kazakhstan' }, { name: 'Moldova' }],
    },
];

export const informationMaterials = [
    {
        label: 'BY PRODUCTS',
        options: [{ name: 'Organic line' }, { name: 'Wuxal' }, { name: 'Fertiplant' }, { name: 'UniferX' }],
    },
];
